// extracted by mini-css-extract-plugin
export default {"input":"ForgotPassword_input__ApDB9","buttons":"ForgotPassword_buttons__Yf62w","buttons__return-to-login":"ForgotPassword_buttons__return-to-login__fw0oy"};